module.exports = __webpack_public_path__ + "static/media/created-icon.6fdf1c5d.svg";